import React, { useMemo } from 'react';
import MirsTable from 'components/general/table/Table.js';
import { findArray, filterArray } from 'helpers/utils';
import { ColumnBib, ColumnNameH2H } from "components/common/TableColumns"
import { NocMemo as Noc } from 'components/presentation/Noc';
import Competitor from 'components/presentation/Competitor';
import { useViewport } from 'components/general/useViewPort'
import Label from "components/general/Label";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";


function BscPlayerStats({ data, team }) {
  const { mirs_rsc, mirs_discipline } = useUrlFriendlyToParameters()
  let athletes = findArray(data?.results?.items, { startSortOrder: [team] })?.teamAthletes;
  let teamTotal = findArray(data?.results?.items, { startSortOrder: [team] })?.statsItems;
  let statsArray = ['Pos', 'GF', 'GA', 'SHOT', 'PTY', 'OHK', 'FOS', 'FOC', 'YC', 'YRC', 'RC'];
  let items = statsArray.map((item) => {
    let val = findArray(teamTotal, { code: [item] })
    return {
      code: item, value: val?.value, attempt: val?.attempt, percent: val?.percent
    }
  })

  let extra = {
    athlete: { code: '100000' },
    bib: 100000,
    title: <strong><Label data='HeaderTotals' /></strong>,
    statsItems:
      items,
  }

  //Before to inser check if exist yet
  if (athletes) {
    athletes = athletes?.filter(item => item.code !== 100000)
    athletes.push(extra)
  }




  let competitorNoc = findArray(data?.results?.items, { startSortOrder: [team] })?.participant?.organisation?.code;
  let competitorCode = findArray(data?.results?.items, { startSortOrder: [team] })?.participant?.code;
  let participant = findArray(data?.results?.items, { startSortOrder: [team] })?.participant;

  //Field Athletes collumns
  const tableColumnsField = useMemo(() =>
    [

      {
        Header: "-",
        enableRowSpan: true,
        relatedId: 'Bib',
        headerClassName: "text-end w-5 text-nowrap align-middle",
        id: 'HeaderBib',
        columns: [
          ColumnBib({ disableSort: true, label: 'HeaderShirtNo', expecialCase: true, remove: true }),
        ]
      },
      {
        Header: "-",
        enableRowSpan: true,
        relatedId: 'Name',
        headerClassName: "text-start align-middle",
        id: 'HeaderName',
        columns: [
          ColumnNameH2H({ showStarter: false, remove: true }),
        ]
      },


      {
        Header: "-",
        enableRowSpan: true,
        relatedId: 'PlayerStatsPos',
        headerClassName: "text-end w-5 align-middle",
        id: 'HeaderStatsPos',
        columns: [
          {
            id: 'PlayerStatsPos',
            Header: <Label data="HeaderPos" />,
            headerClassName: "text-end w-5",
            className: 'text-end',
            isVisible: false,
            columnIndex: 1,
            remove: true,
            Cell: (props) => {
              let code = props?.cell?.row?.original?.athlete?.code
              let ath = athletes?.find(ath => ath?.athlete?.code === code)
              let role = ''
              if (ath)
                role = findArray(ath?.eventUnitEntries, { eue_code: ['POSITION'] }).eue_value
              return role
            }
          }
        ]
      },

      {
        Header: "-",
        enableRowSpan: true,
        relatedId: 'PlayerStatsGF',
        headerClassName: "text-end w-5 align-middle",
        id: 'HeaderStatsGF',
        columns: [
          {
            id: 'PlayerStatsGF',
            Header: <Label data="HeaderGF" />,
            headerClassName: "text-end",
            className: 'text-end w-5',
            isVisible: false,
            columnIndex: 2,
            remove: true,
            Cell: (props) => {
              let value = findArray(props?.cell?.row?.original?.statsItems, { code: ['GF'] }).value;
              return value

            }
          },
        ]
      },
      {
        Header: "-",
        enableRowSpan: true,
        relatedId: 'PlayerStatsGA',
        headerClassName: "text-end w-5 align-middle",
        id: 'HeaderStatsGA',
        columns: [
          {
            id: 'PlayerStatsGA',
            Header: <Label data="HeaderGA" />,
            headerClassName: "text-end",
            className: 'text-end w-5',
            isVisible: false,
            columnIndex: 3,
            remove: true,
            Cell: (props) => {
              let value = findArray(props?.cell?.row?.original?.statsItems, { code: ['GA'] }).value;
              return value
            }
          }
        ]
      },

      {
        Header: "-",
        enableRowSpan: true,
        relatedId: 'PlayerStatsSG/S',
        headerClassName: "text-end w-5 align-middle",
        id: 'HeaderStatsSG/S',
        columns: [
          {
            id: 'PlayerStatsSG/S',
            Header: <Label data="HeaderSG/S" sport={mirs_discipline} />,
            headerClassName: "text-end",
            className: 'text-end w-5',
            isVisible: false,
            columnIndex: 4,
            remove: true,
            Cell: (props) => {
              let value = findArray(props?.cell?.row?.original?.statsItems, { code: ['SHOT'] }).value;
              let attempt = findArray(props?.cell?.row?.original?.statsItems, { code: ['SHOT'] }).attempt;
              return (
                <><PlayerStatsType1 value={value} attempt={attempt} /></>
              )
            }
          }
        ]
      },


      {
        Header: "-",
        enableRowSpan: true,
        relatedId: 'PlayerStatsPK',
        headerClassName: "text-end w-5 align-middle",
        id: 'HeaderStatsPK',
        columns: [
          {
            id: 'PlayerStatsPK',
            Header: <Label data="HeaderPK" sport={mirs_discipline} />,
            headerClassName: "text-end",
            className: 'text-end w-5',
            isVisible: false,
            columnIndex: 5,
            remove: true,
            Cell: (props) => {
              let value = findArray(props.cell.row.original.statsItems, { code: ['PTY'] }).value;
              let attempt = findArray(props.cell.row.original.statsItems, { code: ['PTY'] }).attempt;
              return (
                <><PlayerStatsType1 value={value} attempt={attempt} /></>
              )
            }
          },
        ]
      },

      {
        Header: "-",
        enableRowSpan: true,
        relatedId: 'PlayerStatsOHK',
        headerClassName: "text-end w-5 align-middle",
        id: 'HeaderStatsOHK',
        columns: [
          {
            id: 'PlayerStatsOHK',
            Header: <Label data="HeaderOH" sport={mirs_discipline} />,
            headerClassName: "text-end",
            className: 'text-end w-5',
            isVisible: false,
            columnIndex: 6,
            remove: true,
            Cell: (props) => {
              let value = findArray(props.cell.row.original.statsItems, { code: ['OHK'] }).value;
              let attempt = findArray(props.cell.row.original.statsItems, { code: ['OHK'] }).attempt;
              return (
                <><PlayerStatsType1 value={value} attempt={attempt} /></>
              )
            }
          },
        ]
      },

      {
        id: 'HeaderFouls',
        Header: <Label data="HeaderFouls" sport={mirs_discipline} />,
        headerClassName: "text-center",
        columns: [
          {
            id: 'PlayerStatsFOC',
            Header: <Label data="HeaderFC" sport={mirs_discipline} />,
            headerClassName: "text-end",
            className: 'text-end w-5',
            isVisible: false,
            columnIndex: 8,
            Cell: (props) => {
              let value = findArray(props.cell.row.original.statsItems, { code: ['FOC'] }).value;
              return value
            }
          },


          {
            id: 'PlayerStatsFOS',
            Header: <Label data="HeaderFS" sport={mirs_discipline} />,
            headerClassName: "text-end",
            className: 'text-end w-5',
            isVisible: false,
            columnIndex: 7,
            Cell: (props) => {
              let value = findArray(props.cell.row.original.statsItems, { code: ['FOS'] }).value;
              return value
            }
          }
        ]
      },

      {
        Header: "-",
        enableRowSpan: true,
        relatedId: 'PlayerStatsYC',
        headerClassName: "text-end w-5 align-middle",
        id: 'HeaderStatsYC',
        columns: [
          {
            id: 'PlayerStatsYC',
            Header: <Label data="HeaderY" sport={mirs_discipline} />,
            headerClassName: "text-end",
            className: 'text-end w-5',
            isVisible: false,
            columnIndex: 8,
            remove: true,
            Cell: (props) => {
              let value = findArray(props.cell.row.original.statsItems, { code: ['YC'] }).value;
              return value
            }
          },
        ]
      },

      {
        id: 'HeaderRedCards',
        Header: <Label data="HeaderRedCards" sport={mirs_discipline} />,
        headerClassName: "text-center",
        columns: [
          {
            id: 'PlayerStatsYRC',
            Header: <Label data="HeaderYRC" sport={mirs_discipline} />,
            headerClassName: "text-end",
            className: 'text-end w-5',
            isVisible: false,
            columnIndex: 8,
            Cell: (props) => {
              let value = findArray(props.cell.row.original.statsItems, { code: ['YRC'] }).value;
              return value
            }
          },
          {
            id: 'PlayerStatsRC',
            Header: <Label data="HeaderR" sport={mirs_discipline} />,
            headerClassName: "text-end",
            className: 'text-end w-5',
            isVisible: false,
            columnIndex: 8,
            Cell: (props) => {
              let value = findArray(props.cell.row.original.statsItems, { code: ['RC'] }).value;
              return value
            }
          }]
      }
      ,
    ], []
  )
  const tableColumnsFieldSM = useMemo(() =>
    [
      ColumnBib({ disableSort: true, label: 'HeaderShirtNo', expecialCase: true }),
      ColumnNameH2H({ showStarter: false }),
      {
        id: 'PlayerStatsPos',
        Header: <Label data="HeaderPos" />,
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 1,
        Cell: (props) => {
          let code = props.cell.row.original.athlete.code
          let ath = athletes.find(ath => ath.athlete.code === code)
          let role = ''
          if (ath)
            role = findArray(ath.eventUnitEntries, { eue_code: ['POSITION'] }).eue_value
          return role
        }
      },
      {
        id: 'PlayerStatsGF',
        Header: <Label data="HeaderGF" />,
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 2,
        Cell: (props) => {
          let value = findArray(props.cell.row.original.statsItems, { code: ['GF'] }).value;
          return value

        }
      },
      {
        id: 'PlayerStatsGA',
        Header: <Label data="HeaderGA" />,
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 3,
        Cell: (props) => {
          let value = findArray(props.cell.row.original.statsItems, { code: ['GA'] }).value;
          return value
        }
      },
      {
        id: 'PlayerStatsSG/S',
        Header: <Label data="HeaderSG/S" sport={mirs_discipline} />,
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 4,
        Cell: (props) => {
          let value = findArray(props.cell.row.original.statsItems, { code: ['SHOT'] }).value;
          let attempt = findArray(props.cell.row.original.statsItems, { code: ['SHOT'] }).attempt;
          return (
            <><PlayerStatsType1 value={value} attempt={attempt} /></>
          )
        }
      },
      {
        id: 'PlayerStatsPK',
        Header: <Label data="HeaderPK" sport={mirs_discipline} />,
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 5,
        Cell: (props) => {
          let value = findArray(props.cell.row.original.statsItems, { code: ['PTY'] }).value;
          let attempt = findArray(props.cell.row.original.statsItems, { code: ['PTY'] }).attempt;
          return (
            <><PlayerStatsType1 value={value} attempt={attempt} /></>
          )
        }
      },
      {
        id: 'PlayerStatsOHK',
        Header: <Label data="HeaderOH" sport={mirs_discipline} />,
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 6,
        Cell: (props) => {
          let value = findArray(props.cell.row.original.statsItems, { code: ['OHK'] }).value;
          let attempt = findArray(props.cell.row.original.statsItems, { code: ['OHK'] }).attempt;
          return (
            <><PlayerStatsType1 value={value} attempt={attempt} /></>
          )
        }
      },
      {
        id: 'PlayerStatsFOS',
        Header: <Label data="HeaderFS" sport={mirs_discipline} />,
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 7,
        Cell: (props) => {
          let value = findArray(props.cell.row.original.statsItems, { code: ['FOS'] }).value;
          return value
        }
      },
      {
        id: 'PlayerStatsFOC',
        Header: <Label data="HeaderFC" sport={mirs_discipline} />,
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 8,
        Cell: (props) => {
          let value = findArray(props.cell.row.original.statsItems, { code: ['FOC'] }).value;
          return value
        }
      },
      {
        id: 'PlayerStatsYC',
        Header: <Label data="HeaderY" sport={mirs_discipline} />,
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 8,
        Cell: (props) => {
          let value = findArray(props.cell.row.original.statsItems, { code: ['YC'] }).value;
          return value
        }
      },
      {
        id: 'PlayerStatsYRC',
        Header: <Label data="HeaderYRC" sport={mirs_discipline} />,
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 8,
        Cell: (props) => {
          let value = findArray(props.cell.row.original.statsItems, { code: ['YRC'] }).value;
          return value
        }
      },
      {
        id: 'PlayerStatsRC',
        Header: <Label data="HeaderR" sport={mirs_discipline} />,
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 8,
        Cell: (props) => {
          let value = findArray(props.cell.row.original.statsItems, { code: ['RC'] }).value;
          return value
        }
      },
    ], []
  )

  let _captionField = <CaptionTeam competitorNoc={competitorNoc} participant={participant} />

  const { breakPoint } = useViewport();
  let columnsField = (breakPoint === "sm" || breakPoint === "xs") ? tableColumnsFieldSM : tableColumnsField

  return (
    <>{ }
      {athletes &&
        <MirsTable
          id={`mirs-table-player-statistics-${team + '-' + mirs_rsc}-${competitorCode}`}
          caption={_captionField}
          data={athletes}
          columns={columnsField}
          keyRow={"athlete-code"}
          initialSortBy={[{ id: 'Bib', desc: false }]}
          colsExtendedVisible={(breakPoint === "sm" || breakPoint === "xs") ? '6,5' : '11,0'}
          showNavExtendedData={(breakPoint === "sm" || breakPoint === "xs") ? true : false}
          colIndex={1}
        />
      }

    </>
  );
}

export default BscPlayerStats;

function CaptionTeam({ competitorNoc, participant }) {
  return (
    <div className='d-flex align-items-center'>
      <div className='d-none d-md-block me-1'>
        <Noc {...participant?.organisation} />
      </div>
      <strong>
        <Competitor hidePicture={true} {...participant} />
      </strong>
    </div>
  )
}

function PlayerStatsType1({ value, attempt }) {
  if (value !== undefined) {
    return (
      <>
        {value}/{attempt}
      </>
    )
  }
}


